import type { BuildProject } from '../types'

/** Build projects for the Hardware Store "Build" flow: step-by-step with tools & materials */
export const HARDWARE_BUILDS: BuildProject[] = [
  {
    id: 'birdhouse',
    name: 'Birdhouse',
    description: 'A cozy house for birds to nest in',
    emoji: '🐦',
    steps: [
      { id: 'bh1', order: 1, label: 'Gather your wood', instruction: 'Get 5 small wooden pieces: front, back, 2 sides, and a roof. Ask a grown-up to help find them.', emoji: '🪵', stage: 'gather' },
      { id: 'bh2', order: 2, label: 'Measure the entrance', instruction: 'On the front piece, mark a circle big enough for a bird. A grown-up can cut it out.', emoji: '⭕', stage: 'measure' },
      { id: 'bh3', order: 3, label: 'Nail the sides', instruction: 'Put the front and back between the two sides. Ask a grown-up to nail them together.', emoji: '🔨', stage: 'assemble' },
      { id: 'bh4', order: 4, label: 'Add the roof', instruction: 'Place the roof on top and nail it down so rain stays out.', emoji: '🏠', stage: 'assemble' },
      { id: 'bh5', order: 5, label: 'Paint it', instruction: 'Paint your birdhouse any color you like! Let it dry before hanging.', emoji: '🎨', stage: 'finish' },
      { id: 'bh6', order: 6, label: "You built it!", instruction: 'Hang it on a tree or pole. Birds will love their new home!', emoji: '🐦', stage: 'done' },
    ],
  },
  {
    id: 'toolbox',
    name: 'Toolbox',
    description: 'A box to keep your tools in',
    emoji: '🧰',
    steps: [
      { id: 'tb1', order: 1, label: 'Get a small box', instruction: 'Find a sturdy wooden or plastic box. Make sure it has a lid!', emoji: '📦', stage: 'gather' },
      { id: 'tb2', order: 2, label: 'Measure for a handle', instruction: 'Mark two spots on the short sides for the handle. A grown-up can drill small holes.', emoji: '📏', stage: 'measure' },
      { id: 'tb3', order: 3, label: 'Add the handle', instruction: 'Thread a rope or wire through the holes and tie it so you can carry the box.', emoji: '🪢', stage: 'assemble' },
      { id: 'tb4', order: 4, label: 'Paint or label it', instruction: 'Write "My Tools" on the lid or paint it your favorite color.', emoji: '✏️', stage: 'finish' },
      { id: 'tb5', order: 5, label: 'All done!', instruction: 'Put your toy tools inside. You have your own toolbox!', emoji: '🧰', stage: 'done' },
    ],
  },
  {
    id: 'picture-frame',
    name: 'Picture Frame',
    description: 'A frame for your favorite drawing or photo',
    emoji: '🖼️',
    steps: [
      { id: 'pf1', order: 1, label: 'Gather 4 sticks', instruction: 'Get 4 craft sticks or small pieces of wood the same length.', emoji: '🪵', stage: 'gather' },
      { id: 'pf2', order: 2, label: 'Glue the corners', instruction: 'Glue the sticks into a rectangle. Hold each corner until the glue sets.', emoji: '🪣', stage: 'assemble' },
      { id: 'pf3', order: 3, label: 'Add the picture', instruction: 'Tape or glue your drawing or photo to the back of the frame.', emoji: '🖼️', stage: 'assemble' },
      { id: 'pf4', order: 4, label: 'Decorate the frame', instruction: 'Paint the frame or add stickers. Make it yours!', emoji: '✨', stage: 'finish' },
      { id: 'pf5', order: 5, label: 'Finished!', instruction: 'Hang it on the wall or give it to someone you love.', emoji: '🖼️', stage: 'done' },
    ],
  },
]
